



























import { Component, Prop, Emit, Ref } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { donorStore } from '@/utils/store-accessor'
import { AtomTextField } from '@/components/atoms'
import { ModalDonor } from '@/components/modals/ModalDonor'
import { defaultDonor, Donor } from '@/api'
import { MaskPattern } from '@/types'
import { cloneDeep } from 'lodash'

@Component({
  components: { ModalDonor }
})
export default class InputCodeDonor extends ComponentVue {
  @Ref()
  textField!: AtomTextField

  @Ref()
  modalDonor!: ModalDonor

  @Prop({ type: String })
  label!: string

  @Prop({ type: String })
  placeholder!: string

  @Prop({ type: String })
  value!: string

  @Prop({
    type: Boolean,
    default: false
  })
  hideName!: boolean

  @Prop({
    type: Boolean,
    default: true
  })
  hideDetails!: boolean

  @Prop({ type: Boolean, default: false })
  error!: boolean

  @Prop({ type: String, default: '' })
  errorMessage!: string

  @Prop({
    type: Boolean,
    default: false
  })
  multiple!: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  disabled!: boolean

  get mask(): string {
    return this.multiple ? MaskPattern.HalfWidthOnly : 'X'.repeat(4)
  }

  get defaultCodes(): string[] {
    return this.value
      .split(',')
      .filter(
        (value, index, array) => value !== '' && array.indexOf(value) === index
      )
  }

  get name(): string {
    if (this.multiple || this.hideName) return ''
    return donorStore.findByCode(this.value)?.shortName ?? ''
  }

  onInput(value: string) {
    this.$emit('input', value)

    const item = donorStore.allItems.find(item => item.code === value)
    this.$emit(
      'input:donor',
      item !== undefined
        ? cloneDeep(item)
        : Object.assign(defaultDonor(), { code: value })
    )
  }

  onModalDonorInput(item: Donor | Donor[]) {
    if (Array.isArray(item)) {
      this.$emit('input', item.map(value => value.code).join(','))
      return
    }

    this.$emit('input', item.code)
    this.$emit('input:donor', item)
  }

  @Emit('click:list')
  onListClick(): void {
    this.modalDonor.open()
  }

  @Emit('keydown:enter')
  onKeydownEnter() {}
}
